
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function ContactHero() {
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 100);
    return () => clearTimeout(t);
  }, []);

  const handleBooking = () => {
    navigate('/equipment-hire');
    setTimeout(() => {
      const el = document.getElementById('booking');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 400);
  };

  return (
    <section className="relative h-[55vh] min-h-[420px] flex items-center justify-center overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/647e98a0a22f03fe9d9cb259410f118b.jpg"
        alt="Contact House of FMR"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70" />

      <div
        className={`relative z-10 text-center px-6 transition-all duration-1000 ease-out ${
          visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}
      >
        <p
          className="text-amber-400 text-xs tracking-[0.4em] uppercase mb-4 font-medium"
          style={{ transitionDelay: '200ms' }}
        >
          Get In Touch
        </p>
        <h1 className="text-5xl md:text-6xl font-light text-white tracking-wide mb-4"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Contact Us
        </h1>
        <div className="w-20 h-px bg-gradient-to-r from-transparent via-amber-400 to-transparent mx-auto mb-5" />
        <p className="text-white/70 text-base max-w-xl mx-auto leading-relaxed mb-8">
          We'd love to hear about your event. Reach out and let's create something unforgettable together.
        </p>
        <button
          onClick={handleBooking}
          className="inline-flex items-center gap-2 px-8 py-3 bg-amber-500 hover:bg-amber-400 text-black text-sm font-semibold tracking-widest uppercase rounded-full transition-all duration-300 shadow-lg hover:shadow-amber-500/30 whitespace-nowrap cursor-pointer"
        >
          <i className="ri-calendar-check-line text-base"></i>
          Book a Consultation
        </button>
      </div>
    </section>
  );
}
